// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__IhZs1","footer":"layout_footer__Wrint"};